import script from "./ProjectCover.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCover.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCover.vue?vue&type=style&index=0&id=4464fece&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4464fece"]])

export default __exports__